import { render } from "./AddressDetails.vue?vue&type=template&id=43f3d74c&ts=true"
import script from "./AddressDetails.vue?vue&type=script&lang=ts"
export * from "./AddressDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__